import SmoothScroll from 'smooth-scroll';
export class Acc {
    constructor() {

        this.toggleMenus = {};
        this.toggleMenus2 = {};

        //その他
        this.hasAccordion = false;
        this.accMinHeight = 300;
        this.scroll = {};
    }

    getStyle(e, styleName) {
        var styleValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            styleValue = document.defaultView.getComputedStyle(e, "").getPropertyValue(styleName);
        } else if (e.currentStyle) {
            styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            styleValue = e.currentStyle[styleName];
        }
        return styleValue.replace(/px/g, '');
    }

    init() {
        //console.log('acc init');
        if (document.getElementById('faq-list-accordion') || document.getElementById('jobdesc-list-accordion')) {
            this.hasAccordion = true;



            this.toggleMenus = document.querySelectorAll('.faq-container');
            [].forEach.call(this.toggleMenus, (elem) => {
                //console.log(elem);
                elem.accElem = elem.querySelector('.answer');
                elem.addEventListener('click', () => {
                    //console.log(elem);
                    this.accClickToggle(elem);
                });
            });


            this.toggleMenus2 = document.querySelectorAll('.jobdesc-container .jobdesc-heading');
            [].forEach.call(this.toggleMenus2, (elem) => {
                elem.addEventListener('click', () => {
                    this.accClickToggle2(elem);
                });
            });


            this.toggleMenus2btn = document.querySelectorAll('.jobdesc-container .jobdesc-btn-close');
            [].forEach.call(this.toggleMenus2btn, (elem) => {
                elem.addEventListener('click', () => {
                    this.accClickToggle2(elem.parentElement.parentElement.parentElement.parentElement.querySelector('.jobdesc-heading'));//.jobdesc-heading
                });
            });


            //scroll
            this.scroll = new SmoothScroll();

        }
    }

    accClickToggle(elem) {

        elem.contentHeight = elem.querySelector('.answer-inner').clientHeight;
        //console.log(elem + ', contentHeight=' + elem.contentHeight);
        if (elem.classList.contains('open')) {
            elem.classList.remove('open');
            elem.accElem.style.height = '0px';
            //console.log('0');
        } else {
            elem.classList.add('open');
            elem.accElem.style.height = elem.contentHeight + 'px';
            //console.log(lem.accElem.style.height);
        }
    }

    accClickToggle2(elem) {
        //console.log(elem);//.jobdesc-heading
        elem.accElem = elem.parentElement.querySelector('.jobdesc-content');
        elem.contentElem = elem.accElem.querySelector('.jobdesc-content-content-height');
        elem.contentHeight = elem.contentElem.clientHeight;
        //console.log(elem + ', contentHeight=' + elem.contentHeight);
        if (elem.classList.contains('open')) {
            elem.classList.remove('open');
            elem.accElem.style.height = '0px';
            //console.log('0');

            //スクロール
            //console.log('scroll to' + elem);
            let options = {
                header: 'header',
                speed: 10,
                speedAsDuration: true,
                updateURL: false //Update the URL on scroll
            };
            this.scroll.animateScroll(elem, null, options);

        } else {
            elem.classList.add('open');
            elem.accElem.style.height = elem.contentHeight + 'px';
            //console.log(lem.accElem.style.height);
        }
    }

    accResize() {

        if (this.hasAccordion) {

            [].forEach.call(this.toggleMenus, (elem) => {
                elem.contentHeight = elem.querySelector('.answer-inner').clientHeight;
                if (elem.classList.contains('open')) {
                    elem.accElem.style.height = elem.contentHeight + 'px';
                }
                //console.log('acc resize: ' + elem.contentHeight);
            });

            [].forEach.call(this.toggleMenus, (elem) => {
                elem.contentHeight = elem.querySelector('.jobdesc-content-content-height').clientHeight;
                if (elem.classList.contains('open')) {
                    elem.accElem.style.height = elem.contentHeight + 'px';
                }
                //console.log('acc resize: ' + elem.contentHeight);
            });

        }
    }

}